import { Route, Switch, useLocation } from 'wouter'
import { useAuth } from './contexts/AuthContext'
import Home from './pages/Home'
import ConsultaPublica from './pages/ConsultaPublica'
import NotFound from './pages/NotFound'
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import StagesManager from './pages/admin/StagesManager'
import DocumentsManager from './pages/admin/DocumentsManager'
import LogsList from './pages/admin/LogsList'
import ConsultaManager from './pages/admin/ConsultaManager'
import ContentManager from './pages/admin/ContentManager'
import { useEffect, useState, useRef } from 'react'

function PrivateRoute({ component: Component, ...rest }: any) {
  const { isAuthenticated, isLoading, checkAuth } = useAuth()
  const [, navigate] = useLocation()
  const [isVerifying, setIsVerifying] = useState(true)

  useEffect(() => {
    const verify = async () => {
      console.log('[PRIVATE_ROUTE] Verificando autenticação...')
      const isValid = await checkAuth()
      setIsVerifying(false)
      
      if (!isValid) {
        console.log('[PRIVATE_ROUTE] ❌ Não autenticado, redirecionando para login')
        navigate('/admin/login')
      } else {
        console.log('[PRIVATE_ROUTE] ✅ Autenticado')
      }
    }
    verify()
  }, [checkAuth, navigate])

  if (isLoading || isVerifying) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0d6b3d] mx-auto mb-4"></div>
          <p className="text-gray-500">Verificando autenticação...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <Component {...rest} />
}

// 🔥 ADMIN REDIRECT - com a variável isAuthenticated USADA
function AdminRedirect() {
  const { isAuthenticated, isLoading } = useAuth()  // ← isAuthenticated é USADO abaixo
  const [, navigate] = useLocation()
  const [isChecking, setIsChecking] = useState(true)
  const redirectedRef = useRef(false)

  useEffect(() => {
    if (redirectedRef.current) return
    
    if (!isLoading) {
      setIsChecking(false)
      
      if (!redirectedRef.current) {
        redirectedRef.current = true
        // 🔥 isAuthenticated é USADO AQUI!
        if (isAuthenticated) {
          console.log('[ADMIN_REDIRECT] ✅ Autenticado, redirecionando para dashboard')
          navigate('/admin/dashboard', { replace: true })
        } else {
          console.log('[ADMIN_REDIRECT] ❌ Não autenticado, redirecionando para login')
          navigate('/admin/login', { replace: true })
        }
      }
    }
  }, [isLoading, isAuthenticated, navigate])

  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0d6b3d] mx-auto mb-4"></div>
          <p className="text-gray-500">Redirecionando...</p>
        </div>
      </div>
    )
  }

  return null
}

function AppRoutes() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/consulta-publica" component={ConsultaPublica} />
      <Route path="/admin/login" component={AdminLogin} />
      {/* 🔥 ROTA /admin REDIRECIONA */}
      <Route path="/admin" component={AdminRedirect} />
      <Route path="/admin/dashboard" component={() => <PrivateRoute component={AdminDashboard} />} />
      <Route path="/admin/stages" component={() => <PrivateRoute component={StagesManager} />} />
      <Route path="/admin/documents" component={() => <PrivateRoute component={DocumentsManager} />} />
      <Route path="/admin/logs" component={() => <PrivateRoute component={LogsList} />} />
      <Route path="/admin/consulta" component={() => <PrivateRoute component={ConsultaManager} />} />
      <Route path="/admin/content" component={() => <PrivateRoute component={ContentManager} />} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default AppRoutes